export default {
  title: 'Catalog Builder',
  auth: {
    title: 'Connexion',
    subtitle: 'Veuillez vous connecter',
    button: 'Se connecter',
    error: {
      title: 'Problème de connexion',
      text:
        'Une erreur est survenue, merci de vérifier vos informations et réessayer à nouveau.'
    }
  },
  nav: {
    catalogs: 'Catalogues',
    categories: 'Catégories',
    menu: 'Menu',
    account: 'Mon compte',
    logout: 'Déconnexion'
  },
  catalog: {
    title: 'Vos catalogues',
    new: 'Nouveau catalogue',
    name: 'Nom du catalogue',
    name_placeholder: 'Ecrivez ici le nom du catalogue',
    themes: 'Thèmes',
    categories: 'Catégories',
    exp_date: "Date d'expiration",
    exp_date_placeholder: 'Sélectionnez une date'
  },
  categories: {
    title: 'Catégories',
    name: 'Nom de la catégorie',
    avatar: 'Image de la catégorie'
  },
  menu: {
    title: 'Edition du menu'
  },
  builder: {
    title: 'Builder'
  },
  account: {
    title: 'Mon compte'
  },
  common: {
    new: 'Nouveau',
    view: 'Consulter',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Sauvegarder',
    uploading: 'Chargement',
    error: {
      title: 'Erreur',
      text:
        'Une erreur est survenue, merci de réessayer plus tard ou de prendre contact avec le support technique.'
    },
    warn: {
      sure_ttl: 'Etes-vous sûr ?',
      sure_text:
        'Un grand pouvoir implique de grandes responsabilités, cette action est définitive...'
    },
    success: {
      title: 'Succès',
      text: "J'adore qu'un plan se déroule sans accros"
    }
  },
  form: {
    placeholders: {
      firstname: 'Prénom',
      lastname: 'Nom',
      email: 'E-mail',
      password: 'Mot de passe',
      company: 'Nom de société',
      address: 'Adresse',
      zipcode: 'Code postal',
      city: 'Ville',
      googleanalytics: 'ID Google Analytics',
      googleanalytics_catalog:
        'ID Google Analytics (remplacera celui par défaut)'
    }
  },
  tools: {
    inputs: {
      title_top: 'Haut du titre',
      title_bottom: 'Bas du titre',
      text: 'Texte',
      img_url: 'image',
      link_url: 'Url du lien',
      title: 'Titre',
      description: 'Description',
      price: 'Prix',
      discounted_price: 'Prix barré',
      ecopart: 'Eco-part',
      btn_label: 'CTA',
      title1: 'Titre 1',
      description1: 'Description 1',
      price1: 'Prix 1',
      discounted_price1: 'Prix barré 1',
      ecopart1: 'Eco-part 1',
      img_url1: 'image 1',
      link_url1: 'Url du lien 1',
      title2: 'Titre 2',
      description2: 'Description 2',
      price2: 'Prix 2',
      discounted_price2: 'Prix barré 2',
      ecopart2: 'Eco-part 2',
      img_url2: 'image 2',
      link_url2: 'Url du lien 2',
      video_id: 'ID de la video Youtube',
      link_url3: 'Url du lien 3',
      link_url4: 'Url du lien 4',
      link_url5: 'Url du lien 5',
      slider_img_1: 'image 1 du slider',
      slider_img_2: 'image 2 du slider',
      slider_img_3: 'image 3 du slider',
      slider_img_4: 'image 4 du slider',
      slider_img_5: 'image 5 du slider',
      max: 'Nbr max'
    }
  }
}
